export const RESOURCE = 'partnersearch';
export const ACTIONS = { Search: '/partners' }